export default "__VITE_ASSET__DalIgcSO__"